/**
 * @format
 */

import { gql } from '@apollo/client';

export const GET_OFFICEUSERS = gql`
  query GetUsersByOfficeAndSiblings($officeIds: [ID!]!) {
    getUsersByOfficeAndSiblings(officeIds: $officeIds) {
      _id
      convosoUserId
      email
      firstName
      lastName
      office {
        officeName
      }
      officeId
      profilePicURL
      role
      statusActive
      username
    }
  }
`;

export const GET_OFFICEUSERSBY_ROLE = gql`
  query GetUsersByOfficeAndSiblingsAndRole($officeIds: [ID!], $role: String) {
    getUsersByOfficeAndSiblingsAndRole(officeIds: $officeIds, role: $role) {
      username
      _id
      lastName
      firstName
      role
    }
  }
`;

export interface UserData {
  _id: string;
  convosoUserId: string;
  email: string;
  firstName: string;
  lastName: string;
  office: {
    officeName: string;
  };
  officeId: string;
  profilePicURL?: string;
  role: string;
  statusActive: boolean;
  username: string;
}
